
import TablePriceType from '../Static/TablePriceType'

const ROUNDING_CENTS = 5

export default class TablePriceCalculator {
  constructor (attributes) {
    this.attributes = attributes
    this.tablePrice = $vm.$store.getters['rummage/tablePrice']
    this.shouldRound = $vm.$store.getters['orders/config']('shouldRound')
  }

  apply () {
    if (! this._isStandardRate()) {
      this._applyRate()
    }
    return this.attributes
  }

  _isStandardRate () {
    return this.tablePrice.id === 1
  }

  _applyRate () {
    this.attributes.price_id = this.tablePrice.id

    this.tablePrice.type === TablePriceType.PERCENTAGE
      ? this._applyPercentageRate()
      : this._applySpecificRate()
  }

  _applyPercentageRate () {
    this._applyContentPercentage()
    this._applyModifiersPercentage()
    this._applyMenuContentsPercentage()
    this._applyCombinationPercentage()
  }

  _applySpecificRate () {
    this._applyContentSpecific()
    this._applyModifiersSpecific()
    this._applyMenuContentsSpecific()
    this._applySellingFormatSpecific()
    this._applyCombinationSpecific()
  }

  _applyContentSpecific () {
    this.attributes.itemPrice = this._specific(this.attributes.itemPrice, {
      type: 'App\\Models\\Menu\\MenuItem',
      id: this.attributes.item_id,
    })
  }

  _applyModifiersSpecific () {
    this.attributes.modifiers = this.attributes.modifiers?.map(modifier => ({
      ...modifier,
      price: this._specific(modifier.price, {
        type: 'App\\Models\\Menu\\Modifier',
        id: modifier.id,
      }),
    })) ?? []
  }

  _applyMenuContentsSpecific () {
    this.attributes.subContents = this.attributes.subContents?.map(subContent => ({
      ...subContent,
      itemPrice: this._specific(subContent.itemPrice, {
        type: 'App\\Models\\Menu\\MenuMenuPivot',
        id: subContent.menuPivotId
      }),
      modifiers: subContent.modifiers?.map(modifier => ({
        ...modifier,
        price: modifier.negationType == 1 ? 0 : this._specific(modifier.price, {
          type: 'App\\Models\\Menu\\Modifier',
          id: modifier.id,
        }, modifier.recalculatePrice),
      })) ?? []
    })) ?? []
  }

  _applySellingFormatSpecific () {
    if (! this.attributes.format_pivot_id) {
      return
    }
    this.attributes.itemPrice = this._specific(this.attributes.itemPrice, {
      type: 'App\\Models\\Menu\\ItemSellingFormatPivot',
      id: this.attributes.format_pivot_id,
    })
  }

  _applyCombinationSpecific () {
    if (! this.attributes.orderContentCombination) {
      return
    }
    this.attributes.orderContentCombination.price = this._specific(this.attributes.orderContentCombination.price, {
      type: 'App\\Models\\Menu\\CombinationGroupMenuItem',
      id: this.attributes.orderContentCombination.combination_id,
    })
  }

  _specific (value, priceable, replace = true) {
    if (! replace) {
      return value
    }

    return $vm.$store.state.rummage.data.Price
      ?.find(o => o.table_price_id == this.tablePrice.id
        && o.priceable_type === priceable.type
        && o.priceable_id == priceable.id
      )
      ?.price
      ?? value
  }

  _applyContentPercentage () {
    this.attributes.itemPrice = this._percentage(this.attributes.itemPrice)
  }

  _applyModifiersPercentage () {
    this.attributes.modifiers = this.attributes.modifiers?.map(modifier => ({
      ...modifier,
      price: modifier.negationType == 1 ? 0 : this._percentage(modifier.price),
    })) ?? []
  }

  _applyMenuContentsPercentage () {
    this.attributes.subContents = this.attributes.subContents?.map(subContent => ({
      ...subContent,
      itemPrice: this._percentage(subContent.itemPrice),
      modifiers: subContent.modifiers?.map(modifier => ({
        ...modifier,
        price: modifier.negationType == 1 ? 0 : this._percentage(modifier.price),
      })) ?? []
    })) ?? []
  }

  _applyCombinationPercentage () {
    if (this.attributes.orderContentCombination?.price) {
      this.attributes.orderContentCombination.price = this._percentage(this.attributes.orderContentCombination.price)
    }
  }

  _percentage (value) {
    value = parseFloat(value)
    if (this.shouldRound) {
      return Math.floor(value * this.tablePrice.percentage / ROUNDING_CENTS) * ROUNDING_CENTS / 100
    }

    return value * this.tablePrice.percentage / 100
  }
}
